import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Permite abrir o drawer de edição de uma lista direto pela URL (`basePath/:id`), por exemplo
 * ao abrir o link de edição em nova aba. Ao fechar o drawer, volta para `basePath`.
 * `open(id)` é chamado uma vez, quando `ready` for verdadeiro.
 */
export default function useEditRoute({ basePath, ready, drawerOpen, open }) {
    const { id } = useParams();
    const navigate = useNavigate();
    const openRef = useRef(open);
    openRef.current = open;
    const handledId = useRef(null);
    const wasOpen = useRef(false);

    useEffect(() => {
        if (id && ready && handledId.current !== id) {
            handledId.current = id;
            openRef.current(Number(id));
        }
    }, [id, ready]);

    useEffect(() => {
        if (drawerOpen) {
            wasOpen.current = true;
        } else if (id && wasOpen.current) {
            wasOpen.current = false;
            navigate(basePath, { replace: true });
        }
    }, [drawerOpen, id, basePath, navigate]);
}
